/**
 * InstaFooter section of editor page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import AngleRight from 'react-icons/lib/fa/angle-right'
import ArrowRight from 'react-icons/lib/fa/arrow-right'
import GoBack from 'react-icons/lib/md/undo'
import * as _ from 'lodash'

import { changeEditorScene } from '../../../actions/locationAC'
import history from 'components/history'
import { media, TEAL, HELVETICA } from '../../styles'

const Wrapper = styled.div`
  ${media.small`height: 75px; font-size: 20px;`}
  ${media.huge`height: 75px; font-size: 26px;`}
  z-index: 1;
`
const Container = styled.div`
  height: 100%;
  width: 100%;
  box-shadow: 0 1px 5px 0 rgba(41,85,115,0.21);

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  overflow: hidden;
  background-color: ${TEAL};
`
const RightButtons = styled.div`
  padding-right: 30px;

  display: flex;
  flex-direction: row;
  align-items: center;

  & button {
    margin-left: 20px;
  }
`
const LeftNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
`
const ButtonNext = styled.div`
  width: 167px;
  height: 50px;
  border-radius: 14px;
  border: solid 3px #ffffff;
  ${HELVETICA};
  font-size: 21px;
  font-weight: 800;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
`
const GoBackButton = styled.div`
  width: 100px;
  height: 50px;
  ${HELVETICA};
  font-size: 15px;
  font-weight: 100;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  margin-right: 30px;
`
const BreadcrumbContainer = styled.div`
  ${HELVETICA};
  font-size: ${props => props.selected ? '17px' : '17px'};
  font-weight: ${props => props.selected ? '800' : '100'};;
  color: white;
  margin-right: 10px;
  margin-left: 10px;
  display: flex;
  height: 40px;
  align-items: center;
`
const BreadcrumbTitle = styled.div`
  ${HELVETICA};
  font-size: ${props => props.selected ? '17px' : '17px'};
  font-weight: ${props => props.selected ? '800' : '100'};
  color: white;
  display: flex;
  height: 30px;
  align-items: center;
  cursor: ${props => props.selected ? 'default' : 'pointer'};
  border-radius: 20px;
  border-width: 1px;
  border-color: ${TEAL};
  border-style: solid;

  &:hover {
    border-color: ${props => props.selected ? TEAL : 'white'};
  }
`

const BreadcrumbsDivider = styled.div`
  color: white;
  margin-left: 20px;
  display: flex;
  align-items: center;
`
const BreadcrumbText = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`


const itemsBase = [
  {id: 0, value: '1. Customize Storefront'},
  {id: 1, value: '2. Tag your Posts'},
  {id: 2, value: '3. Preview & Publish'}
]

class InstaFooter extends Component {

  onBreadcrumbClick = (item) => {
    return (e) => {
      e.preventDefault()
      const { location, dispatch } = this.props
      if (location.sceneNum !== item.id + 1) {
        dispatch(changeEditorScene(item.id + 1))
      }
    }
  }

  renderBreadcrumbs () {
    const { location } = this.props
    const itemsCount = location.sceneNum > 1 ? location.sceneNum : 1
    const items = _.take(itemsBase, itemsCount)
    const activeId = itemsCount - 1
    return (
      _.map(items, (item, index) => {
        return (
          <BreadcrumbContainer key={item.id} onClick={this.onBreadcrumbClick(item)}>
            <BreadcrumbTitle selected={activeId === item.id}>
              <BreadcrumbText>{item.value}</BreadcrumbText>
            </BreadcrumbTitle>
            {(index < items.length - 1) ? <BreadcrumbsDivider><AngleRight /></BreadcrumbsDivider> : null}
          </BreadcrumbContainer>
        )
      })
    )
  }

  onGoBack = () => {
    const { location, dispatch } = this.props
    if (location.sceneNum > 1) dispatch(changeEditorScene(location.sceneNum - 1))
  }

  onNextStep = () => {
    const { location, dispatch } = this.props
    if (location.sceneNum < itemsBase.length) dispatch(changeEditorScene(location.sceneNum + 1))
  }

  renderGoBackButton () {
    const { location } = this.props
    if (location.sceneNum > 1) {
      return (
        <GoBackButton onClick={this.onGoBack}>
          <GoBack />GoBack
        </GoBackButton>
      )
    }
  }

  goToDashboard = () => {
    history.push('/dashboard/myApps')
  }

  renderNextButton () {
    const { location } = this.props
    if (location.sceneNum === itemsBase.length) {
      return <ButtonNext onClick={this.goToDashboard}>Done!</ButtonNext>
    } else {
      return <ButtonNext onClick={this.onNextStep}>Next Step<ArrowRight /></ButtonNext>
    }
  }

  render () {
    return (
      <Wrapper>
        <Container>
          <LeftNav>
            {this.renderBreadcrumbs()}
          </LeftNav>

          <RightButtons>
            {this.renderGoBackButton()}
            {this.renderNextButton()}
          </RightButtons>
        </Container>
      </Wrapper>
    )
  }
}

InstaFooter.propTypes = {
  location: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  location: state.location
})

export default connect(mapStateToProps)(InstaFooter)



// WEBPACK FOOTER //
// ./src/components/editor/insta/InstaFooter.js